import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  Estimation,
  EstimationColumn,
  EstimationColumnEnum,
  SelectableEstimation,
} from '../../models/estimation.model';
import { EstimationService } from '../../../core/estimation.service';
import { ProjectsList } from '../../models/projects.model';
import { Priority } from '../../models/priority.model';
import { Status } from '../../models/status.model';
import { EstimationFilters } from '../../models/estimation.model';
import { UsersWho } from '../../models/requisition.model';
import { Router } from '@angular/router';
import { endOfMonth } from 'date-fns';
import { Clipboard } from '@angular/cdk/clipboard';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-estimation-table',
  templateUrl: './estimation-table.component.html',
  styleUrl: './estimation-table.component.scss',
})
export class EstimationTableComponent implements OnInit {
  @Input() project?: ProjectsList | 'all';

  private _projectId: number | 'all' = 0;
  @Input() set projectId(value: number | 'all') {
    this._projectId = value;
  }
  get projectId(): number | 'all' {
    return this._projectId;
  }

  get projectName(): string | 'all' {
    return this.project !== 'all'
      ? this.project?.projectName || ''
      : 'Todos los proyectos' + (this.selectedApplicationDates.dates?.length === 0 ? ' - Últimos 30 días' : '');
  }

  @Input() estimationTabsList: string[] = [];
  @Input() extraActionButtonText: string = 'Ir a mis requisiciones';
  @Input() estimationTableData: Estimation[] = [];
  @Input() showAuthorizeColumn: boolean = false;
  @Input() totalEstimations: number = 0;
  @Input() currentPage: number = 2;
  @Input() pageSize: number = 0;
  @Input() loading: boolean = false;
  @Input() priorityList: Priority[] = [] as Priority[];
  @Input() statusList: Status[] = [] as Status[];
  @Input() progressList: Status[] = [] as Status[];
  @Input() typesList: Status[] = [] as Status[];
  @Input() appliedFilters!: EstimationFilters;
  @Input() order: string = '';
  @Input() usersInEstimations: UsersWho = {
    userWhoAuthorizes: ([] = []),
    userWhoBuys: ([] = []),
    userWhoRequests: ([] = []),
    userWhoReviews: ([] = []),
  };
  @Input() showUserWhoAuthorizesColumn = false;
  @Input() showUserWhoBuysColumn = false;
  @Input() showUserWhoRequestsColumn = false;
  @Input() showUserWhoReviewsColumn = false;
  @Input() selectedEstimations: Set<number> = new Set();
  @Input() canPrint = false;@Input() userPermissions?: {
    canViewAmounts?: boolean;
    isAdmin?: boolean;
  };
  @Output() changeEstimationTab = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() filterByProvider = new EventEmitter<void>();
  @Output() descriptionTextFilter = new EventEmitter<string>();
  @Output() projectFilter = new EventEmitter<string>();
  @Output() totalCostFilter = new EventEmitter<{filterType: number | null, value: number | null}>();
  @Output() sortColumn = new EventEmitter<{
    columnName: string;
    direction: string;
  }>();
  @Output() priorityFilter = new EventEmitter<Priority[]>();
  @Output() statusFilter = new EventEmitter<Status[]>();
  @Output() progressFilter = new EventEmitter<Status[]>();
  @Output() typeFilter = new EventEmitter<Status[]>();
  @Output() applicationDateFilter = new EventEmitter<{
    dates?: Date[];
    columnName?: string;
  }>();
  @Output() expectedDeliveryDateFilter = new EventEmitter<{
    dates?: Date[];
    columnName?: string;
  }>();
  @Output() highlightEstimation = new EventEmitter<{
    estimation: Estimation;
    tableIndex: number;
  }>();
  @Output() deleteEstimation = new EventEmitter<number>();
  @Output() goToEstimationDetails = new EventEmitter<Estimation>();
  @Output() userWhoBuysFilter = new EventEmitter<{
    user: User[];
    columnName: string;
  }>();
  @Output() userWhoAuthorizesFilter = new EventEmitter<{
    user: User[];
    columnName: string;
  }>();
  @Output() userWhoReviewsFilter = new EventEmitter<{
    user: User[];
    columnName: string;
  }>();
  @Output() userWhoRequestsFilter = new EventEmitter<{
    user: User[];
    columnName: string;
  }>();
  @Output() idTextFilter = new EventEmitter<string>();
  @Output() folioTextFilter = new EventEmitter<string>();
  @Output() clearAllFilters = new EventEmitter<void>();
  @Output() checkedEstimations = new EventEmitter<{id: number, checked: boolean}[]>();
  @Output() exportEstimations = new EventEmitter<'selected' | 'all'>();

  @ViewChild('folioInput') folioInput?: ElementRef;
  @ViewChild('idInput') idInput?: ElementRef;
  @ViewChild('descriptionInput') descriptionInput?: ElementRef;
  @ViewChild('projectInput') projectInput?: ElementRef;
  @ViewChild('totalCostInput') totalCostInput?: ElementRef;

  public estimationTableDataBackup: Estimation[] = [];
  public currentTab = 0;
  public areAllEstimationsSelected: boolean = false;
  public currentPageEstimations: SelectableEstimation[] = [];
  public selectedPriority: Priority[] = [] as Priority[];
  public selectedStatus: Status[] = [] as Status[];
  public selectedProgress: Status[] = [] as Status[];
  public selectedType: Status[] = [] as Status[];
  public selectedApplicationDates: { dates?: Date[]; columnName?: string } = {};
  public selectedExpectedDeliveryDates: {
    dates?: Date[];
    columnName?: string;
  } = {};
  public selectedIdFilter: string = '';
  public selectedFolioFilter: string = '';
  public selectedDescriptionFilter: string = '';
  public selectedProjectFilter: string = '';
  public selectedTotalCostFilter: number | null = null;
  public selectedTotalCostFilterType: number | null = null;
  public isSelectedIdFilter: boolean = false;
  public isSelectedFolioFilter: boolean = false;
  public isSelectedDescriptionFilter: boolean = false;
  public isSelectedProjectFilter: boolean = false;
  public isSelectedTotalCostFilter: boolean = false;
  public estimationCheckableColumnsList: any[] = [];
  public openedNotes = new Set<number>();
  public selectedSortColumn: string = '';
  public selectedSortDirection: string = '';
  public isSortActive = false;
  public selectedUserWhoBuys: User[] = [];
  public selectedUserWhoAuthorizes: User[] = [];
  public selectedUserWhoReviews: User[] = [];
  public selectedUserWhoRequests: User[] = [];
  public paginatorItems: number[] = [];
  public itemsPerPage: number[] = [10, 20, 30, 50];
  public areFiltersEmpty = true;
  public estimatedTotal: number = 0;
  public totalCostFilterTypes = [
    { label: 'Igual', icon: '', value: 1 },
    { label: 'Diferente', icon: '', value: 2 },
    { label: 'Mayor que', icon: '', value: 7 },
    { label: 'Menor que', icon: '', value: 8 },
    { label: 'Mayor igual que', icon: '', value: 9 },
    { label: 'Menor igual que', icon: '', value: 10 },
    // { label: 'Entre', icon: '', value: 11 },
    // { label: 'No entre', icon: '', value: 12 },
  ];

  public estimationColumnsEnum = EstimationColumnEnum;
  public estimationColumnsList: EstimationColumn[] = [
    {
      title: 'Proyecto',
      name: 'project',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '350px',
      align: 'left',
    },
    {
      title: 'Proveedor',
      name: 'providerName',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '350px',
      align: 'left',
    },
    {
      title: 'Folio',
      name: 'estimationFolio',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '120px',
      align: 'left',
    },
    {
      title: 'ID',
      name: 'estimationKey',
      hasShowAndHideColumnFilter: true,
      isVisible: false,
      hasSearchFilter: true,
      isSortable: true,
      width: '200px',
      align: 'left',
    },
    {
      title: 'Descripción',
      name: 'estimationDescription',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '350px',
      align: 'left',
    },
    {
      title: 'Fecha de estimación',
      name: 'estimationApplicationDate',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasDateFilter: true,
      isSortable: true,
      width: '230px',
      align: 'center',
    },
    {
      title: 'Creador',
      name: 'userWhoRequests',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '350px',
      align: 'left',
    },
    {
      title: 'Tipo',
      name: 'estimationType',
      hasShowAndHideColumnFilter: true,
      isVisible: false,
      hasSelectableFilter: true,
      isSortable: true,
      width: '140px',
      align: 'center',
    },
    {
      title: 'Importe',
      name: 'totalCost',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSearchFilter: true,
      isSortable: true,
      width: '230px',
      align: 'center',
    },
    {
      title: 'Prioridad',
      name: 'estimationPriority',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSelectableFilter: true,
      isSortable: true,
      width: '140px',
      align: 'center',
    },
    {
      title: 'Estado',
      name: 'estimationStatus',
      hasShowAndHideColumnFilter: true,
      isVisible: false,
      hasSelectableFilter: true,
      isSortable: true,
      width: '200px',
      align: 'center',
    },
    {
      title: 'Proceso actual',
      name: 'estimationProgress',
      hasShowAndHideColumnFilter: true,
      isVisible: true,
      hasSelectableFilter: true,
      isSortable: true,
      width: '200px',
      align: 'center',
    },
    {
      title: '',
      name: 'Actions',
      hasShowAndHideColumnFilter: false,
      isVisible: true,
      width: '50px',
      align: 'center',
    },
  ];
  public ranges = {
    Ayer: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1)),
    ],
    Hoy: [new Date(), new Date()],
    Mañana: [
      new Date(new Date().setDate(new Date().getDate() + 1)),
      new Date(new Date().setDate(new Date().getDate() + 1)),
    ],
    'Últimos 7 días': [
      new Date(new Date().setDate(new Date().getDate() - 7)),
      new Date(),
    ],
    'Semana pasada': [
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
      ),
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
      ),
    ],
    'Esta semana': [
      new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
      new Date(
        new Date().setDate(new Date().getDate() + (6 - new Date().getDay()))
      ),
    ],
    'Próxima semana': [
      new Date(
        new Date().setDate(new Date().getDate() + (7 - new Date().getDay()))
      ),
      new Date(
        new Date().setDate(new Date().getDate() + (13 - new Date().getDay()))
      ),
    ],
    'Próximos 7 días': [
      new Date(),
      new Date(new Date().setDate(new Date().getDate() + 7)),
    ],
    'Últimos 30 días': [
      new Date(new Date().setDate(new Date().getDate() - 30)),
      new Date(),
    ],
    'Mes pasado': [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      endOfMonth(new Date(new Date().getFullYear(), new Date().getMonth() - 1)),
    ],
    'Este mes': [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endOfMonth(new Date()),
    ],
    'Próximo mes': [
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
      endOfMonth(new Date(new Date().getFullYear(), new Date().getMonth() + 1)),
    ],
    'Próximos 30 días': [
      new Date(),
      new Date(new Date().setDate(new Date().getDate() + 30)),
    ],
  };

  constructor(private router: Router, private clipboard: Clipboard) {}

  ngOnInit(): void {
    if (this.currentPage === 0) this.currentPage = 1;
  }

  ngOnChanges(): void {
    this.paginatorItems =
      this.totalEstimations / this.pageSize
        ? [
            ...Array(Math.ceil(this.totalEstimations / this.pageSize)).keys(),
          ].map((x) => x + 1)
        : [];
    this.estimationTableDataBackup = [...this.estimationTableData];
    this.estimationCheckableColumnsList = [...this.estimationColumnsList];
    this.currentPageEstimations = [
      ...this.estimationTableData.map((y, i) => ({
        estimationId: i,
        estimationDescription: y.estimationDescription,
        isSelected: false,
        isIdTooltipVisible: false,
        isFolioTooltipVisible: false,
      })),
    ];
    this.validateSelectedEstimations();
    this.convertParamsToAppliedFilters(this.appliedFilters);
    this.convertParamsToSort(this.order);
    this.estimatedTotal = +this.estimationTableData.reduce(
      (acc, curr) => acc + (curr.totalCost || 0),
      0
    ).toFixed(2);
  }

  onFilterByProvider() {
    this.filterByProvider.emit();
  }

  onExportEstimations(value: 'all' | 'selected') {
    if (value === 'selected' && this.selectedEstimations.size === 0) return
    this.exportEstimations.emit(value);
  }

  onChangeEstimationTab(tab: number) {
    this.currentTab = tab;
    this.changeEstimationTab.emit(tab);
  }

  goToEstimations() {
    this.router.navigate(['/requisiciones/all']);
  }

  onFilterColumnsList(e: any) {
    if (e.target.value.length == '') {
      this.estimationCheckableColumnsList = [...this.estimationColumnsList];
      return;
    }
    this.estimationCheckableColumnsList = [
      ...this.estimationColumnsList.filter((y) =>
        y.title.toLowerCase().includes(e.target.value.toLowerCase())
      ),
    ];
  }

  onSelectEstimation(index: number, e: boolean) {
    const currentSelected =
      this.currentPageEstimations.filter((x) => x.isSelected);
    const areAllSelected =
      this.currentPageEstimations.length === currentSelected.length;
    if (e) {
      this.currentPageEstimations[index].isSelected = true;
      if (areAllSelected) this.areAllEstimationsSelected = true;
    } else {
      this.currentPageEstimations[index].isSelected = false;
      if (!areAllSelected) this.areAllEstimationsSelected = false;
    }
    this.checkedEstimations.emit([{id: this.currentPageEstimations[index].estimationId, checked: e}]);
  }

  onSelectAllEstimations() {
    if (this.areAllEstimationsSelected) {
      this.currentPageEstimations.forEach((y) => (y.isSelected = true));
    } else {
      this.currentPageEstimations.forEach((y) => (y.isSelected = false));
    }
    this.checkedEstimations.emit(
      this.currentPageEstimations.map((x) => { return {id: x.estimationId, checked: x.isSelected}})
    );
  }

  onSortColumn(columnName: string) {
    if (!columnName) return;
    if (columnName === this.selectedSortColumn) {
      if (this.selectedSortDirection === 'desc') {
        this.selectedSortColumn = '';
        this.selectedSortDirection = '';
        this.isSortActive = false;
      } else {
        this.selectedSortDirection = 'desc';
      }
    } else {
      this.isSortActive = true;
      this.selectedSortColumn = columnName;
      this.selectedSortDirection = 'asc';
    }
    this.sortColumn.emit({
      columnName: columnName,
      direction: this.selectedSortDirection,
    });
  }

  onShowFolioFilter() {
    setTimeout(() => {
      this.folioInput?.nativeElement.focus();
    }, 200);
  }

  onShowIdFilter() {
    setTimeout(() => {
      this.idInput?.nativeElement.focus();
    }, 200);
  }

  onShowDescriptionFilter() {
    setTimeout(() => {
      this.descriptionInput?.nativeElement.focus();
    }, 200);
  }

  onShowProjectFilter() {
    setTimeout(() => {
      this.projectInput?.nativeElement.focus();
    }, 200);
  }
  
  onShowTotalCostFilter() {
    setTimeout(() => {
      this.totalCostInput?.nativeElement.focus();
    }, 200);
  }

  onIdFilterChange(value: string) {
    this.idTextFilter.emit(value);
    this.isSelectedIdFilter = false;
  }

  onResetIdFilter() {
    this.idTextFilter.emit('');
    this.selectedIdFilter = '';
    this.isSelectedIdFilter = false;
  }

  onFolioFilterChange(value: string) {
    this.folioTextFilter.emit(value);
    this.isSelectedFolioFilter = false;
  }

  onResetFolioFilter() {
    this.folioTextFilter.emit('');
    this.selectedFolioFilter = '';
    this.isSelectedFolioFilter = false;
  }

  onDescriptionFilterChange(value: string) {
    this.descriptionTextFilter.emit(value);
    this.isSelectedDescriptionFilter = false;
  }

  onResetDescriptionFilter() {
    this.descriptionTextFilter.emit('');
    this.selectedDescriptionFilter = '';
    this.isSelectedDescriptionFilter = false;
  }

  onProjectFilterChange(value: string) {
    this.projectFilter.emit(value);
    this.isSelectedProjectFilter = false;
    this.currentPage = 1;
  }

  onResetProjectFilter() {
    this.projectFilter.emit('');
    this.selectedProjectFilter = '';
    this.isSelectedProjectFilter = false;
  }

  onDateFilterChange(
    rangeSelected: Date[],
    column: string,
    isAdding = true
  ): void {
    if (isAdding) {
      if (column === 'estimationApplicationDate') {
        this.selectedApplicationDates = {
          dates: rangeSelected,
          columnName: column,
        };
        this.applicationDateFilter.emit(this.selectedApplicationDates);
      } else if (column === 'estimationExpectedDeliveryDate') {
        this.selectedExpectedDeliveryDates = {
          dates: rangeSelected,
          columnName: column,
        };
        this.expectedDeliveryDateFilter.emit(
          this.selectedExpectedDeliveryDates
        );
      }
    } else {
      if (column === 'estimationApplicationDate') {
        this.selectedApplicationDates = {};
        this.applicationDateFilter.emit(this.selectedApplicationDates);
      } else if (column === 'estimationExpectedDeliveryDate') {
        this.selectedExpectedDeliveryDates = {};
        this.expectedDeliveryDateFilter.emit(
          this.selectedExpectedDeliveryDates
        );
      }
    }
  }

  onUserFilter(e: any, columnName: string) {
    this.userWhoBuysFilter.emit({ user: e, columnName: columnName });
  }

  onPriorityFilterChange(priority: Priority, isAdding = true) {
    if (
      isAdding &&
      this.selectedPriority.findIndex((x) => x.id === priority.id) === -1
    ) {
      this.selectedPriority.push(priority);
    } else {
      this.selectedPriority = this.selectedPriority.filter(
        (y) => y.id !== priority.id
      );
    }
    this.priorityFilter.emit(this.selectedPriority);
  }

  onStatusFilterChange(status: Status, isAdding = true) {
    if (
      isAdding &&
      this.selectedStatus.findIndex((x) => x.id === status.id) === -1
    ) {
      this.selectedStatus.push(status);
    } else {
      this.selectedStatus = this.selectedStatus.filter(
        (y) => y.id !== status.id
      );
    }
    this.statusFilter.emit(this.selectedStatus);
  }

  onProgressFilterChange(progress: Status, isAdding = true) {
    if (
      isAdding &&
      this.selectedProgress.findIndex((x) => x.id === progress.id) === -1
    ) {
      this.selectedProgress.push(progress);
    } else {
      this.selectedProgress = this.selectedProgress.filter(
        (y) => y.id !== progress.id
      );
    }
    this.progressFilter.emit(this.selectedProgress);
    this.currentPage = 1;
  }

  onTypeFilterChange(type: Status, isAdding = true) {
    if (
      isAdding &&
      this.selectedType.findIndex((x) => x.id === type.id) === -1
    ) {
      this.selectedType.push(type);
    } else {
      this.selectedType = this.selectedType.filter(
        (y) => y.id !== type.id
      );
    }
    this.typeFilter.emit(this.selectedType);
  }

  onTotalCostFilterChange(filterType: number, value: number) {
    this.totalCostFilter.emit({filterType: filterType, value: value});
    this.isSelectedTotalCostFilter = false;
    this.currentPage = 1;
  }

  onResetTotalCostFilter() {
    this.totalCostFilter.emit({filterType: null, value: null});
    this.selectedTotalCostFilterType = null;
    this.isSelectedTotalCostFilter = false;
    this.selectedTotalCostFilter = null;
  }

  onClearAllFilters() {
    if (!this.appliedFilters) return;
    this.selectedPriority = [];
    this.selectedStatus = [];
    this.selectedProgress = [];
    this.selectedType = [];
    this.selectedApplicationDates = {};
    this.selectedExpectedDeliveryDates = {};
    this.selectedProjectFilter = '';
    this.selectedDescriptionFilter = '';
    this.selectedTotalCostFilter = null;
    this.selectedTotalCostFilterType = null;
    this.selectedSortColumn = '';
    this.selectedSortDirection = '';
    this.isSortActive = false;
    this.selectedUserWhoBuys = [];
    this.selectedUserWhoAuthorizes = [];
    this.selectedUserWhoReviews = [];
    this.selectedUserWhoRequests = [];
    this.clearAllFilters.emit();
  }

  onCopyToClipboard(value: string, index: number, $event: any, isIdColumn: boolean = false) {
    $event.stopPropagation();
    $event.preventDefault();
    if (value === '') return
    this.clipboard.copy(value);
    isIdColumn ? this.currentPageEstimations[index].isIdTooltipVisible = true
      : this.currentPageEstimations[index].isFolioTooltipVisible = true;

    setTimeout(() => {
      isIdColumn ? this.currentPageEstimations[index].isIdTooltipVisible = false
        : this.currentPageEstimations[index].isFolioTooltipVisible = false;
    }, 1000);
  }

  onGoToEstimationDetails(estimation: Estimation, $event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.goToEstimationDetails.emit(estimation);
  }

  onHighlightEstimation(
    data: Estimation,
    isHighlighted: boolean,
    tableIndex: number,
    $event: any
  ) {
    $event.stopPropagation();
    $event.preventDefault();
    this.highlightEstimation.emit({
      estimation: { ...data, estimationIsHighlighted: isHighlighted },
      tableIndex: tableIndex,
    });
  }

  onSelectNote(id: number, $event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.openedNotes.has(id)
      ? this.openedNotes.delete(id)
      : this.openedNotes.add(id);
  }

  onCloseNote(id: number) {
    this.openedNotes.delete(id);
  }

  onDeleteEstimation(index: number, $event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.deleteEstimation.emit(index);
  }

  onPageIndexChange(newPage: number) {
    this.currentPage = newPage;
    this.pageChange.emit(this.currentPage);
  }

  onPageSizeChange(newPageSize: number) {
    this.pageSize = newPageSize;
    this.pageSizeChange.emit(this.pageSize);
  }

  convertParamsToAppliedFilters(params: EstimationFilters): void {
    if (params === undefined) return;
    this.areFiltersEmpty = this.validateFiltersEmptiness();

    this.selectedPriority = [
      ...this.priorityList.filter((x) =>
        params.priorities.includes(x.id.toString())
    ),
    ];
    this.selectedStatus = [
      ...this.statusList.filter((x) => params.states.includes(x.id.toString())),
    ];
    this.selectedProgress = [
      ...this.progressList.filter((x) => params.progress.includes(x.id.toString())),
    ];
    this.currentTab = this.selectedProgress.length === 1 ? this.selectedProgress[0].id + 1 : 0;
    this.selectedType = [
      ...this.typesList.filter((x) => params.wpsType.includes(x.id.toString())),
    ];
    this.selectedApplicationDates = params.applicationDate
      ? {
          dates: [...params.applicationDate.map((x) => new Date(x))],
          columnName: 'estimationApplicationDate',
        }
      : this.selectedApplicationDates;
    this.selectedExpectedDeliveryDates = params.expectedDeliveryDate
      ? {
          dates: [...params.expectedDeliveryDate.map((x) => new Date(x))],
          columnName: 'estimationExpectedDeliveryDate',
        }
      : this.selectedExpectedDeliveryDates;
    this.selectedIdFilter = params.idFilter ? params.idFilter : '';
    this.selectedFolioFilter = params.folioFilter ? params.folioFilter : '';
    this.selectedDescriptionFilter = params.descriptionFilter
      ? params.descriptionFilter
      : '';
    this.selectedProjectFilter = params.projectFilter
      ? params.projectFilter
      : '';
    this.selectedTotalCostFilter = params.totalCostFilter
      ? params.totalCostFilter
      : null;
    this.selectedTotalCostFilterType = params.totalCostType
      ? params.totalCostType
      : null;
    if (params.usersFilter && params.usersFilter.userWhoRequests.length > 0) {
      if (!this.usersInEstimations?.userWhoRequests) return;
      this.selectedUserWhoRequests = [
        ...this.usersInEstimations.userWhoRequests.filter((x) =>
          params.usersFilter!.userWhoRequests.includes(x.id)
        ),
      ];
    }
    if (params.usersFilter && params.usersFilter.userWhoBuys.length > 0) {
      if (!this.usersInEstimations?.userWhoBuys) return;
      this.selectedUserWhoBuys = [
        ...this.usersInEstimations.userWhoBuys.filter((x) =>
          params.usersFilter!.userWhoBuys.includes(x.id)
        ),
      ];
    }
  }

  convertParamsToSort(params: string): void {
    if (params === undefined) return;
    const [columnName, direction] = params.split('|');
    this.selectedSortColumn = columnName;
    this.selectedSortDirection = direction;
  }

  blockEvent($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
  }

  private validateFiltersEmptiness() {
    return (this.appliedFilters.applicationDate?.length === 0 &&
            this.appliedFilters.descriptionFilter === '' &&
            this.appliedFilters.projectFilter === '' &&
            this.appliedFilters.expectedDeliveryDate?.length === 0 &&
            this.appliedFilters.folioFilter === '' &&
            this.appliedFilters.idFilter === '' &&
            this.appliedFilters.priorities.length === 0 &&
            this.appliedFilters.states.length === 0 &&
            this.appliedFilters.progress.length === 0 &&
            this.appliedFilters.usersFilter?.userWhoAuthorizes.length === 0 &&
            this.appliedFilters.usersFilter?.userWhoBuys.length === 0 &&
            this.appliedFilters.usersFilter?.userWhoRequests.length === 0 &&
            this.appliedFilters.usersFilter?.userWhoReviews.length === 0
    );
  }

  private validateSelectedEstimations() {
    this.currentPageEstimations.forEach((y) => {
      if (this.selectedEstimations.has(y.estimationId)) y.isSelected = true;
    })
    if (this.currentPageEstimations.length > 0 &&
      this.currentPageEstimations.every((z) => z.isSelected === true)) {
      this.areAllEstimationsSelected = true;
    } else {
      this.areAllEstimationsSelected = false;
    }
  }

  displayAuthIdentifier(user: User) {
    if(user && user.name) 
      return user.name;

    if(user && user.key)
      return user.key;

    return 'No disponible';
  }
}
